import React, { Component } from 'react'
import styled, { keyframes } from 'styled-components'
import { Link } from 'react-router-dom'
import onClickOutside from 'react-onclickoutside'
import Scroll from 'react-scroll'
import { Collapse } from 'react-collapse'
const scroll = Scroll.animateScroll
const MobileMenuContainer = styled.div`
  position: relative;
`
const Hamburger = styled.div`
  height: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  & > div {
    width: 24px;
    height: 3px;
    background-color: ${props => (props.type === 'propduct' ? '#fff' : '#333')};
    transition: 0.4s linear;
  }
  ${props =>
    props.close &&
    `
    & > div:nth-child(1) {
      transform: rotate(-45deg) translate(-3px,1px)
    }
    & > div:nth-child(2) {
      opacity: 0;
    }
    & > div:nth-child(3) {
      transform: rotate(45deg) translate(-8px, -7px);
    }
  `};
`
const fadeInRight = keyframes`
  from {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
`
const MenuWrapper = styled.div`
  animation: ${fadeInRight} 0.2s linear;
  display: flex;
  flex-direction: column;
  transition: 0.2s linear;
  position: fixed;
  height: 100%;
  z-index: 999999999999999;
  top: 50px;
  right: ${props => (props.hideMenuWrapper ? '-200px' : '0px')};
  width: 190px;
  background-color: #ffffff;
  padding: 20px;
  & > img {
    align-self: flex-end;
  }
`
const MenuGrid = styled.div`
  // margin-top: 10px;
`
const MenuItems = styled.div`
  // padding: 10px 0px;
  padding-bottom: 10px;
`
const ItemName = styled.p`
  font-size: 14px;
  line-height: 1.64;
  letter-spacing: 1.4px;
  color: #999999;
`
const ProductsWrapper = styled.div`
  font-size: 14px;
  line-height: 1.64;
  letter-spacing: 1.4px;
  color: #999999;
  padding-bottom: 10px;
`
const Overlay = styled.div`
  position: fixed;
  display: block;
  min-width: 100%;
  height: 100%;
  top: 50px;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.73);
  z-index: 99999;
  cursor: pointer;
  max-width: 768px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  display: ${props => (props.navBg ? 'none' : 'block')};
`

const ArrowIcon = styled.span`
  border: solid #a5a5a5;
  border-width: 0 1.5px 1.5px 0;
  display: inline-block;
  padding: 3px;
  transition: all 0.16s;
  top: -2px;
  position: relative;
  transform: ${props => (props.rotate ? 'rotate(-135deg)' : 'rotate(45deg)')};
`
class MobileMenu extends Component {
  state = {
    hideMenuWrapper: true,
    close: false,
    collapse: false,
    collapse2: false,
    navbg: false
  }

  handleClickOutside(event) {
    this.setState({
      hideMenuWrapper: true,
      close: false,
      navbg: false
    })
  }
  scrollToTop = () => {
    if (this.props.location.pathname === '/careers' || this.props.location.pathname === '/aboutus') {
      this.props.history.push('/')
    }
    scroll.scrollToTop()
  }
  render() {
    const { hideMenuWrapper, close } = this.state
    return (
      <MobileMenuContainer>
        <Hamburger
          type={this.props.type}
          close={close}
          onClick={() => this.setState({ hideMenuWrapper: !hideMenuWrapper, close: !close })}>
          <div />
          <div />
          <div />
        </Hamburger>
        <Overlay navBg={hideMenuWrapper}>
          <MenuWrapper hideMenuWrapper={hideMenuWrapper}>
            <MenuGrid>
              <MenuItems>
                <Link to="/">
                  <ItemName>Home</ItemName>
                </Link>
              </MenuItems>
              <MenuItems>
                <Link to="/about">
                  <ItemName>About Us</ItemName>
                </Link>
              </MenuItems>

              <ProductsWrapper onClick={() => this.setState({ collapse2: !this.state.collapse2 })}>
                <Link to="/services">
                  <ItemName>Services</ItemName>
                </Link>{' '}
                <ArrowIcon rotate={this.state.collapse2} />
                <Collapse isOpened={this.state.collapse2}>
                  <MenuItems>
                    <Link to="/services/web-development">
                      <ItemName>Web Development</ItemName>
                    </Link>
                    <Link to="/services/app-development">
                      <ItemName> App Development</ItemName>
                    </Link>
                    <Link to="/services/digital-marketing">
                      <ItemName> Digital Marketing</ItemName>
                    </Link>
                    <Link to="/services/web-crawling">
                      <ItemName> Web Crawling</ItemName>
                    </Link>
                    <Link to="/services/ux-ui">
                      <ItemName> UX/UI</ItemName>
                    </Link>
                  </MenuItems>
                </Collapse>
              </ProductsWrapper>

              <MenuItems>
                <Link to="/clients">
                  <ItemName>Clients</ItemName>
                </Link>
              </MenuItems>

              <ProductsWrapper onClick={() => this.setState({ collapse: !this.state.collapse })}>
                Products <ArrowIcon rotate={this.state.collapse} />
                <Collapse isOpened={this.state.collapse}>
                  <MenuItems>
                    <Link to="/trckr">
                      <ItemName>Trckr</ItemName>
                    </Link>
                  </MenuItems>
                  <MenuItems>
                    <Link to="/extract">
                      <ItemName>Extract</ItemName>
                    </Link>
                  </MenuItems>
                  <MenuItems>
                    <Link to="/books">
                      <ItemName>Books</ItemName>
                    </Link>
                  </MenuItems>
                </Collapse>
              </ProductsWrapper>
              <MenuItems>
                <Link to="/contact">
                  <ItemName>Contact</ItemName>
                </Link>
              </MenuItems>
            </MenuGrid>
          </MenuWrapper>
        </Overlay>
      </MobileMenuContainer>
    )
  }
}
export default onClickOutside(MobileMenu)



// WEBPACK FOOTER //
// ./src/components/MobileMenu.js